import { Box, ThemeContext } from '@migros/msrc-ui-kit';
import React, { useContext } from 'react';
import { ListStyleType } from '../../helpers';
import { Card } from '../../elements/card/Card';
import { FixedRatioContainer } from '../../elements/fixed-ratio-container/FixedRatioContainer';
import { SkeletonBox } from './SkeletonBox';
export const ArticleSkeleton = ({
  mode = ListStyleType.default
}) => {
  const theme = useContext(ThemeContext);

  // TODO document hardcoded box heights or make them dynamic
  return /*#__PURE__*/React.createElement(Card, {
    mode: mode,
    theme: theme,
    "data-testid": "msrc-articles--article-skeleton"
  }, /*#__PURE__*/React.createElement(FixedRatioContainer, null, /*#__PURE__*/React.createElement(SkeletonBox, null)), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: '24px',
      margin: '10px 75% 10px 0'
    },
    position: ['relative']
  }, /*#__PURE__*/React.createElement(SkeletonBox, null)), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: '16px',
      margin: '10px 10% 6px 0'
    },
    position: ['relative']
  }, /*#__PURE__*/React.createElement(SkeletonBox, null)), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: '16px',
      margin: '6px 20% 6px 0'
    },
    position: ['relative']
  }, /*#__PURE__*/React.createElement(SkeletonBox, null)), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: '16px',
      margin: '6px 45% 10px 0'
    },
    position: ['relative']
  }, /*#__PURE__*/React.createElement(SkeletonBox, null)));
};